import React from "react";
import {Box} from "@mui/material";
import {drawerWidth} from "../drawer/CustomDrawer";
import {palette} from "../../technical/style/theme";
import {useTranslation} from "react-i18next";

export function AppSubTitle() {

  const {t} = useTranslation();
  return (
    <Box sx={{
      width: drawerWidth,
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      borderBottom: '3px solid ' + palette.primary,
    }}>
      <Box sx={{
        margin: 'auto',
        fontSize: '1.1rem',
        color: palette.normal,
        ...palette.greyTextOpacity
      }}>
        {t('appSubTitle')}
      </Box>
    </Box>
  );
}
